export const SHOPIFY_CONFIG = {
  storeDomain: `${process.env.REACT_APP_SHOPIFY_STORE}.myshopify.com`, // Replace with your store domain
  storefrontAccessToken: process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN, // Replace with your token
  apiVersion: '2024-01',
};

export const SHOPIFY_GRAPHQL_URL = `https://${SHOPIFY_CONFIG.storeDomain}/api/${SHOPIFY_CONFIG.apiVersion}/graphql.json`;